import { Component, Input, OnInit } from '@angular/core'
import { ControlContainer, UntypedFormControl } from '@angular/forms'
import { UntilDestroy } from '@ngneat/until-destroy'
import { ISelectItem } from '../input/input.interface'

@UntilDestroy()
@Component({
  selector: 'mg-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  standalone: false
})
export class CheckboxComponent implements OnInit {
  @Input() controlName: string
  @Input() label = ''
  @Input() labelClass = ''
  @Input() item?: ISelectItem
  @Input() disabled = false
  @Input() disableColorChange = true
  @Input() pill = false

  formControl: UntypedFormControl

  constructor(private controlContainer: ControlContainer) {}

  ngOnInit(): void {
    this.formControl = this.controlContainer.control?.get(this.controlName) as UntypedFormControl
  }

  toggleCheckbox(value?: string) {
    if (this.disabled) {
      return
    }
    if (value && this.item) {
      const temp: string[] = this.formControl?.value ?? []
      const formValue = [...temp]
      const foundIndex = formValue.findIndex((el) => el === value)
      if (foundIndex < 0) {
        formValue.push(value)
      } else {
        formValue.splice(foundIndex, 1)
      }
      this.formControl?.setValue(formValue)
    } else {
      this.formControl?.setValue(!this.formControl?.value)
    }
  }
}
